import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, observable, Observable, throwError } from 'rxjs';
import { map, retry, catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { User } from '../../shared/interfaces/user';
import * as moment from 'moment';
//import { error } from 'util';
import { token_response } from '../interfaces/token_response';
import { JsonResult } from '../interfaces/JsonResult';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }



    login(username: string, password: string): Observable<any> {

        const path = `${environment.apiUrl}/api/user/signin`;

        return this.http
            .post<any>(path,
                {
                    'username': username,
                    'password': password
                }, this.httpOptions)
            .pipe(

                map(jsonresult => {

                    console.log(jsonresult);

                    if (jsonresult.success) {

                        let user;

                        user = jsonresult.data?.result;

                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('currentUser', JSON.stringify(user));
                        console.log(localStorage.getItem('currentUser'));
                        this.currentUserSubject.next(user);
                        this.setSession(user);
                    }
                    return jsonresult;

                })

            );
    }

    forget(model): Observable<any> {

        const path = `${environment.apiUrl}/api/user/ForgetPassword`;

        return this.http
            .post<any>(path, model, this.httpOptions)
            .pipe(
                map(jsonresult => {
                    return jsonresult;
                })
            );
    }

    signup(model): Observable<any> {
        return this.http
            .post<any>(`${environment.apiUrl}/api/user/join`,
                model, this.httpOptions)
            .pipe(
                map(res => {
                    return res;
                })
            );
    }

    verify(model): Observable<any> {

        return this.http
            .post<any>(`${environment.apiUrl}/api/user/verification`,
                model, this.httpOptions)
            .pipe(
                map(res => {
                    return res;
                })
            );
    }

    sendVerify(model): Observable<JsonResult> {


        return this.http
            .post<any>(`${environment.apiUrl}/api/user/sendverification`,
                model, this.httpOptions)
            .pipe(
                map(res => {
                    return res;
                })
            );
    }

    private setSession(authResult) {
        const expiresAt = moment().add(authResult.expires_in, 'second');

        // alert(authResult.expires_in);
        // localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('Token', authResult.token);
        localStorage.setItem('Expires_in', JSON.stringify(expiresAt.valueOf()));
        console.log(localStorage.getItem('currentUser'));
        // this.currentUserSubject.next();

        // console.log(localStorage.getItem('token'));


    }


    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        // localStorage.removeItem("id_token");
        localStorage.removeItem('Expires_in');
        localStorage.removeItem('Token');

        this.currentUserSubject.next(null);
    }

    public isLoggedIn() {
        const isExpire = moment().isBefore(this.getExpiration());
        return isExpire;
    }

    isLoggedOut() {
        return !this.isLoggedIn();
    }

    getExpiration() {
        const expiration = localStorage.getItem('Expires_in');
        const expiresAt = JSON.parse(expiration);

        return moment(expiresAt);
    }
    getCurrent(): any {
        const u = localStorage.getItem('currentUser');
        console.log(u);
        return u;
    }
}


interface ClientError {
    code: string;
    description: string;
}
